const enum CATEGORY_ID {
  YUESAO = '月嫂',
  YUEZICENTER = '月子中心',
  CHANKANG = '产康',
  CHANHOUKANGFU = '产后恢复',
  PHOTOGRAPHY = '摄影',
  BAIRIZHAO = '百日照'
}


export const CATEGORY_ID_MAP = {
    [CATEGORY_ID.YUESAO]: "10112210",
    [CATEGORY_ID.YUEZICENTER]: "10111018",
    [CATEGORY_ID.CHANKANG]: "10112110",
    [CATEGORY_ID.CHANHOUKANGFU]: "10112110",
    [CATEGORY_ID.PHOTOGRAPHY]: "10121115",
    [CATEGORY_ID.BAIRIZHAO]: "10121115",
}
